import React from 'react'
import {withRouter} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {resetEditState} from 'lms/store/actions'
import {
  styled,
  Button as MuiButton,
} from '@material-ui/core'

const Button = styled(MuiButton)(({theme}) => ({
  color: theme.palette.primary.contrastText,
}))

const CreateAppButton = ({history, ...props}) => {
  const dispatch = useDispatch()
  
  const handleClick = () => {
    // Reset edit state before navigating to ensure no old data is present
    //console.log('CreateAppButton: Resetting edit state before creating new application')
    dispatch(resetEditState())
    
    // Navigate to the new application form
    history.push("/systems/new")
  }

  return (
    <Button onClick={handleClick}>
      Create Learning System
    </Button>
  )
}

export default withRouter(CreateAppButton)
